<script>
import ProductActions from '#/v-shop-base-layout/vue-src/v-shop/product/comp_ProductActions.vue'

export default {
	extends: ProductActions,
	props: {
		qtyModel: {
			type: Number,
			default: 1,
		},
	},
	model: {
		prop: 'qtyModel',
		event: 'updateQtyModel',
	},
	watch: {
		qty(value) {
			this.$emit('updateQtyModel', value)
		},
		qtyModel(value) {
			this.qty = value
		},
	},
}
</script>

